const translations = {
  'wWithUs.seo.title': 'Work with us in Barcelona | TEFL Iberia',
  'wWithUs.seo.description':
    'Find out more about working as a teacher trainer on our prestigious Trinity CertTESOL courses in Barcelona.',
  'wWithUs.sec1.title': 'TEFL Iberia is Hiring!',
  'wWithUs.sec1.description':
    'We are looking for qualified course tutors for our Trinity CertTESOL courses in Barcelona. The role is primarily to lead morning input sessions for the Trinity CertTESOL course, assess trainees and liaise with Trinity College London.',
  'wWithUs.sec1.description2':
    'We are also taking applications for English teaching positions within our school.',
  'wWithUs.sec1.c1.benefitsTitle': 'The main responsibilities will include:',
  'wWithUs.sec1.c1.ben1': 'Preparing and delivering input sessions.',
  'wWithUs.sec1.c1.ben2': 'Continual development of the course.',
  'wWithUs.sec1.c1.ben3': 'Teaching demo lessons.',
  'wWithUs.sec1.c1.ben4': 'Assessing trainees.',
  'wWithUs.sec1.c1.ben5': 'Organising the teaching practice timetable.',
  'wWithUs.sec1.c1.ben6': 'Taking overall responsibility for the smooth running of the course.',

  'wWithUs.sec1.c2.benefitsTitle': 'Essential requirements:',
  'wWithUs.sec1.c2.ben1': ' Minimum 4 years teaching experience in a range of backgrounds.',
  'wWithUs.sec1.c2.ben2': 'One year of teacher training experience.',
  'wWithUs.sec1.c2.ben3': 'A passion for teaching.',
  'wWithUs.sec1.c2.ben4':
    'Diploma level qualification in TEFL (Cambridge DELTA, Trinity DipTESOL, PGCE in TEFL, etc).',

  'wWithUs.sec1.c3.benefitsTitle': 'Desirable:',
  'wWithUs.sec1.c3.ben1': 'Autónomo status.',
  'wWithUs.sec1.c3.ben2': 'Previous management / customer service experience.',
  'wWithUs.sec1.c3.ben3': 'Knowledge of the Trinity CertTESOL syllabus and organisation.',
  'wWithUs.sec1.c3.ben4': 'Be registered in the Autonomous regime.',

  'wWithUs.sec2.notice':
    'If you are interested in joining the TEFL Iberia team, please complete the form below:',

  'wWithUs.sec2.form': 'Application Form',
  'wWithUs.sec2.firstName': 'First Name',
  'wWithUs.sec2.lastName': 'Last Name',
  'wWithUs.sec2.email': 'Email',
  'wWithUs.sec2.tel': 'Telephone',
  'wWithUs.sec2.nationality': 'Nationality',
  'wWithUs.sec2.qualification': 'What teaching qualifications do you have?',
  'wWithUs.sec2.spainStatus': 'What best describes your status in Spain?',
  'wWithUs.sec2.selectOption': 'Select your preferred choice',
  'wWithUs.sec2.coverLetter': 'Cover letter',
  'wWithUs.sec2.apply': 'Apply',
};

export default translations;
